import { lazy, Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { AuthSplitLayout } from 'src/layouts/auth-split';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';
import { paths } from 'src/routes/paths';

const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/jwt/sign-in')),
  SignUpPage: lazy(() => import('src/pages/auth/jwt/sign-up')),
  VerifyPage: lazy(() => import('src/pages/auth/jwt/verify')),
  ResetPasswordPage: lazy(() => import('src/pages/auth/jwt/reset-password')),
  UpdatePasswordPage: lazy(() => import('src/pages/auth/jwt/update-password')),
  InvitationPage: lazy(() => import('src/pages/auth/jwt/invitation')),
};

const split = (page, guest = false) => {
  const content = (
    <AuthSplitLayout
      section={{
        title: 'رادو؛ مدیریت هوشمند ناوگان',
        subtitle: 'مدیریت هوشمند ناوگان، با دقت و امنیت بالا',
      }}
    >
      {page}
    </AuthSplitLayout>
  );
  return guest ? <GuestGuard>{content}</GuestGuard> : content;
};

function LegacyJwtRedirect({ to }) {
  const location = useLocation();
  const target = `${to}${location.search}${location.hash}`;

  return <Navigate to={target} replace />;
}

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      { path: 'sign-in', element: split(<Jwt.SignInPage />, true) },
      { path: 'sign-up', element: split(<Jwt.SignUpPage />, true) },
      { path: 'verify', element: split(<Jwt.VerifyPage />) },
      { path: 'reset-password', element: split(<Jwt.ResetPasswordPage />, true) },
      { path: 'update-password', element: split(<Jwt.UpdatePasswordPage />) },
      { path: 'invitation', element: split(<Jwt.InvitationPage />) },
      {
        path: 'jwt',
        children: [
          { path: 'sign-in', element: <LegacyJwtRedirect to={paths.auth.jwt.signIn} /> },
          { path: 'sign-up', element: <LegacyJwtRedirect to={paths.auth.jwt.signUp} /> },
          { path: 'verify', element: <LegacyJwtRedirect to={paths.auth.jwt.verify} /> },
          {
            path: 'reset-password',
            element: <LegacyJwtRedirect to={paths.auth.jwt.resetPassword} />,
          },
          {
            path: 'update-password',
            element: <LegacyJwtRedirect to={paths.auth.jwt.updatePassword} />,
          },
        ],
      },
    ],
  },
];
